import Axios from "./axios";
import { fileToJpegDataUrl } from "./fileToJpegDataUrl";
const axios = new Axios();

const isProfilePictureUploadPath = (uploadPath: string, userId: string) =>
  uploadPath.replace(/\/+$/, "").endsWith(`user/profile-pictures/${userId}`);

export const uploadImage = async (
  photo: File,
  userId: string,
  path: string,
): Promise<string | undefined> => {
  try {
    if (!photo) {
      return undefined;
    }

    const isProfilePhoto = isProfilePictureUploadPath(path, userId);
    const timestamp = new Date().getTime();
    const fileName = isProfilePhoto ? "photo" : `${timestamp}${photo.name}`;
    const extension = isProfilePhoto ? "jpg" : fileName.split(".").pop();
    const fileNameWithoutExtension = isProfilePhoto
      ? "photo"
      : fileName.slice(0, -(extension ? extension.length + 1 : "croppedImage"));

    const dataUrl = isProfilePhoto
      ? await fileToJpegDataUrl(photo)
      : await readFileAsDataUrl(photo);
    const base64FileData = dataUrl.split(",")[1];

    const cleanedFileName = fileNameWithoutExtension
      .replace(/[\s.]/g, "")
      .replace(/\s/g, "");

    const response = await axios.Post("/upload-files", {
      fileData: base64FileData,
      fileName: cleanedFileName.trim(),
      extension: extension,
      path: `${path}${userId}`,
    });

    if (response.status === 200) {
      return response.data.image as string;
    }
    console.error(
      "Error uploading file. Status:",
      response.status,
      "Data:",
      response.data,
    );
    return undefined;
  } catch (error) {
    console.error("Error handling cropped image upload:", error);
    return undefined;
  }
};

function readFileAsDataUrl(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      if (typeof reader.result === "string") {
        resolve(reader.result);
      }
      else {
        reject(new Error("Invalid file read result"));
      }
    };
    reader.onerror = () => reject(reader.error ?? new Error("FileReader failed"));
    reader.readAsDataURL(file);
  });
}
